import React from 'react';
import Select from '@/components/ui/Select';
import FormItem from '@/components/ui/FormItem';
import { useEmployer } from '../_hooks/useEmployer';
import type { FormItemProps } from '@/components/views/Resolution886/types';

export function EmployerFormItem({ fieldName = '', required = true }: Readonly<FormItemProps>): JSX.Element {
	const { isLoading, data, addItem, handleSearch, handleInputChange } = useEmployer({ fieldName });

	return (
		<FormItem label="Employer" name={fieldName} requiredMessage="Please select an employer" required={required}>
			<Select.Multiple
				isAdd
				isSingle
				options={data}
				textButton="Add"
				addItem={addItem}
				loading={isLoading}
				placeholder="Select an employer"
				onSearch={handleSearch}
				placeholderInput="Please enter an employer"
				onInputChange={handleInputChange}
			/>
		</FormItem>
	);
}
